import { create } from "zustand";

export type AppView =
  | "landing"
  | "login"
  | "register"
  | "dashboard"
  | "academy"
  | "course"
  | "commission"
  | "ai-accounts"
  | "order-site"
  | "vpn" // VPN management (only for users with vpnAccess)
  | "payments"
  | "admin";

type AppState = {
  view: AppView;
  /** selected course slug (for the course player view) */
  selectedCourseSlug: string | null;
  /** stored ?ref= value captured on first load, used to prefill register */
  capturedRef: string | null;
  setView: (v: AppView) => void;
  openCourse: (slug: string) => void;
  setCapturedRef: (ref: string | null) => void;
};

export const useAppStore = create<AppState>((set) => ({
  view: "landing",
  selectedCourseSlug: null,
  capturedRef: null,
  setView: (v) => set({ view: v }),
  openCourse: (slug) => set({ selectedCourseSlug: slug, view: "course" }),
  setCapturedRef: (ref) => set({ capturedRef: ref }),
}));

const VALID_VIEWS: AppView[] = [
  "landing",
  "login",
  "register",
  "dashboard",
  "academy",
  "course",
  "commission",
  "ai-accounts",
  "order-site",
  "vpn",
  "payments",
  "admin",
];

// Initialize view + ?ref= from URL on first client load
export function initRouteFromUrl() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const v = params.get("view") as AppView | null;
  if (v && VALID_VIEWS.includes(v)) {
    useAppStore.getState().setView(v);
  }
  const ref = params.get("ref");
  if (ref) {
    useAppStore.getState().setCapturedRef(ref.trim().toUpperCase());
  }
}

export function pushView(v: AppView) {
  useAppStore.getState().setView(v);
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    if (v === "landing") {
      url.searchParams.delete("view");
    } else {
      url.searchParams.set("view", v);
    }
    window.history.replaceState({}, "", url.toString());
  }
}

export function openCourse(slug: string) {
  useAppStore.getState().openCourse(slug);
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    url.searchParams.set("view", "course");
    url.searchParams.set("course", slug);
    window.history.replaceState({}, "", url.toString());
  }
}
